import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Login } from '@/components/Login';
import { FullPageSpinner } from '@/components/FullPageMessage';
import { useAuthStore } from '@/stores/authStore';

type LoginSearch = { returnTo?: string };

function safeReturnTo(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\') || value === '/login' || value.startsWith('/login?') || value.startsWith('/login/')) {
    return '/';
  }
  return value;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    returnTo: safeReturnTo(search.returnTo ?? search.redirect),
  }),
  component: LoginPage,
});

function LoginPage() {
  const { returnTo = '/' } = Route.useSearch();
  const { isAuthenticated, isInitializing, checkAuth } = useAuthStore();

  useEffect(() => {
    if (isInitializing) void checkAuth();
  }, [checkAuth, isInitializing]);

  if (isInitializing) return <FullPageSpinner />;
  if (isAuthenticated) return <Navigate to={returnTo} />;
  return <Login redirect={returnTo} />;
}
